var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorStandWithLeg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.372,
    height: 257.545,
    viewBox: "0 0 117.372 257.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#2a3561}.cls-2,.cls-4,.cls-7,.cls-8{stroke:#2a3561;stroke-width:.5px;stroke-miterlimit:10}.cls-2{fill:#ffc99d;stroke-linecap:round}.cls-4{fill:#2b5889}.cls-7{fill:#fff}.cls-8{fill:#3ba5f4}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    transform: "translate(498.648 -288.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    fill: "#2a3561",
    stroke: "#2a3561",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M-439.48 290.667a9.717 9.717 0 0 1 3.507 4.443c.874 2.782 2.494 8.183 3.762 13.825 1.829 8.138 3.789 15.988-.888 20.665s-8.347 8.32-8.347 8.32H-475.1s13.35-42.061 16.185-44.987a16.538 16.538 0 0 1 19.435-2.266z",
    transform: "translate(-5.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    d: "M0 0H11.704V19.214H0z",
    className: "cls-2",
    transform: "translate(-460.153 324.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    d: "M-444.493 341.394s2.107 3.672 9.2 5.072l.63-1.037v-4.743z",
    className: "cls-3",
    transform: "translate(-13.789 -13.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    d: "M-443.182 295.907c-12.956 0-11.71 7.849-11.71 7.849V319.7c0 2.78 1.462 5.879 4.769 8.528l.086.068a11.44 11.44 0 0 0 14.187-.08l.08-.066a11.106 11.106 0 0 0 4.3-8.451v-15.943s1.244-7.849-11.712-7.849z",
    className: "cls-2",
    transform: "translate(-11.12 -1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    d: "M-423.365 312.279s2.479-1.463 3.325 1.234c1.1 3.518-3.325 6.515-3.325 6.515z",
    className: "cls-2",
    transform: "translate(-19.194 -5.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    d: "M-456.128 312.279s-2.479-1.463-3.325 1.234c-1.1 3.518 3.325 6.515 3.325 6.515z",
    className: "cls-2",
    transform: "translate(-9.916 -5.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    d: "M-435.553 350.687l6.1 1.466-7.872 47.191 3.043 7.634h-20.354l.5-55.57 4.919-.721 6.269 8.674z",
    className: "cls-4",
    transform: "translate(-11.194 -15.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_105",
    fill: "#0096c1",
    stroke: "#2a3561",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M11.189 0L0 15.096",
    transform: "translate(-465.332 343.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_54",
    d: "M0 0H12.219V108.008H0z",
    className: "cls-2",
    transform: "translate(-466.521 427.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_55",
    d: "M0 0H12.219V5.932H0z",
    className: "cls-3",
    transform: "translate(-466.521 478.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    fill: "#ffc99d",
    stroke: "#2a3561",
    strokeLinecap: "round",
    strokeWidth: "0.5px",
    d: "M2.852.37L15.664 0l-2.852 110.508-12.812.37z",
    transform: "rotate(-12.904 1668.076 2205.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    d: "M-413.994 545.26l1.38 7.576h13.08l-1.36-7.576z",
    className: "cls-3",
    transform: "translate(-23.71 -68.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    d: "M-466.392 514.833h62.2l-33.094-88.5h-29.1z",
    className: "cls-4",
    transform: "translate(-8.186 -35.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    d: "M-463.236 351.655l-9.531 1.028a15.059 15.059 0 0 0-8.81 3.921 12.5 12.5 0 0 0-3.918 7.609c-1.068 8.474-4.7 64.417-4.7 64.417h11.1v55.3s14.946-1.922 14.946-18.577.913-113.698.913-113.698z",
    className: "cls-7",
    transform: "translate(-2.097 -16.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    d: "M-409.272 363.6l-7.206 50.445 26.744 66.3s-5.285 6.406-15.694 2.883-11.05-18.416-11.05-18.416l-14.893-64.965 7.872-47.191 14.868 3.9z",
    className: "cls-7",
    transform: "translate(-17.146 -16.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    d: "M-408.7 443.157a1.045 1.045 0 0 0-.231-.3 8.239 8.239 0 0 0-3.7-1.651c-2.252-.5-4.5.925-5.336 1.535a1.049 1.049 0 0 0-.434.735 2.2 2.2 0 0 0 .351 1.518 1.086 1.086 0 0 1-.363 1.616l-3.079 1.553a1.077 1.077 0 0 0-.5 1.4l.179.4a1.077 1.077 0 0 1-.5 1.4l-.458.23a1.077 1.077 0 0 0-.5 1.4l.712 1.608 1.52-.709.521 1.124a1.077 1.077 0 0 0 1.4.536 1.077 1.077 0 0 1 1.378.481l.418.784a1.078 1.078 0 0 0 1.051.566 25.446 25.446 0 0 0 8.194-2.023 18.577 18.577 0 0 0 3.643-2.207 1.068 1.068 0 0 0 .254-1.318z",
    className: "cls-2",
    transform: "translate(-19.196 -39.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    d: "M-421.56 352.657l14.868 3.9 23.139 52.91a6.308 6.308 0 0 1-2 7.578l-16.93 12.669a3.041 3.041 0 0 1-4.376-.783l-5.595-8.646a3.042 3.042 0 0 1 .575-3.962l10.324-8.84-22.237-41.444z",
    className: "cls-7",
    transform: "translate(-19.085 -16.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    d: "M-418.443 353.933s3.172 1.716 3.385 5.025-3.385 8.221-3.385 8.221 2.424 4.271 2.211 7.153c-.166 2.238-9.087 16.387-13.066 22.6a.717.717 0 0 1-1.31-.506l7.3-43.767z",
    className: "cls-7",
    transform: "translate(-17.338 -16.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    d: "M-462.633 352.091s-3.416 1.156-4.185 4.382 1.95 8.674 1.95 8.674-3.11 3.8-3.387 6.678c-.214 2.234 6.191 17.685 9.065 24.479a.716.716 0 0 0 1.376-.278l.189-44.371z",
    className: "cls-7",
    transform: "translate(-7.708 -16.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_106",
    d: "M0 57.975L0 0",
    className: "cls-7",
    transform: "translate(-481.186 354.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    d: "M-461.057 600.435c-4.708.148-6.223-2.235-6.223-2.235l-2.451-.3a58.087 58.087 0 0 1-11.471 4.461c-6.986 1.961-16 3.239-16.887 5.117s.211 3.3 3.218 3.523 34.544.669 36.4.49 3.882-1.083 4.115-2.137-.359-11.455-.359-11.455-1.633 2.388-6.342 2.536z",
    className: "cls-8",
    transform: "translate(0 -66.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    d: "M-395.072 598.141c4.566-1.157 5.364-3.865 5.364-3.865l2.273-.964a58.009 58.009 0 0 0 12.257 1.123c7.255-.042 16.271-1.3 17.643.259s.708 3.229-2.12 4.274-33.019 10.175-34.852 10.516-4.03.03-4.545-.919-2.833-11.488-2.833-11.488 2.246 2.223 6.813 1.064z",
    className: "cls-8",
    transform: "translate(-24.69 -64.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    d: "M-454.355 295.333c-1.645 2.469-2.677 7.688-2.471 11.166h1.409a11.214 11.214 0 0 0 5.891-5.917 18.782 18.782 0 0 0 .961-2.526c3.4 2.945 9.2 6.709 16.633 6.709h1.751s-2.01-9.51-4.562-11.659c-1.526-1.284-5.792-2.331-8.931-2.263",
    className: "cls-3",
    transform: "translate(-10.627 -.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    fill: "none",
    stroke: "#2a3561",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M-456.817 308.979h1.409a11.214 11.214 0 0 0 5.891-5.917 18.788 18.788 0 0 0 .962-2.526c3.4 2.945 9.2 6.709 16.632 6.709h1.751",
    transform: "translate(-10.636 -3.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    d: "M-485.289 455.1s-1.174 8.968-1.174 11.424 0 9.395 1.174 10.142a12.1 12.1 0 0 0 2.562 1.175h1.175v-10.789s4.056 4.7 5.124 3.1.427-3.1-1.708-5.125V455.1z",
    className: "cls-2",
    transform: "translate(-3.051 -42.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_107",
    d: "M0 2.764L5.646 0",
    className: "cls-2",
    transform: "translate(-440.231 412.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_108",
    d: "M4.188 0L0 2.02",
    className: "cls-2",
    transform: "translate(-437.252 414.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_109",
    d: "M0 2.719L5.917 0",
    className: "cls-2",
    transform: "translate(-441.503 409.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_110",
    d: "M0 1.718L3.633 0",
    className: "cls-2",
    transform: "translate(-437.177 405.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    d: "M-444.167 334.183s.96.961 3.772.961 3.7-.961 3.7-.961",
    className: "cls-2",
    transform: "translate(-13.872 -11.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_111",
    fill: "#027393",
    stroke: "#2a3561",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M0 0L15.182 88.503",
    transform: "translate(-456.684 391.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_112",
    d: "M0 5.261L5.688 0",
    className: "cls-7",
    transform: "translate(-420.64 385.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    d: "M-440.193 316.524l-2.616 7.686a1.64 1.64 0 0 0 1.552 2.168h2.217",
    className: "cls-2",
    transform: "translate(-14.197 -7.17)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorStandWithLeg);
export default __webpack_public_path__ + "static/media/doctorStandWithLeg.b477b13e468a8b4d9853856782402a89.svg";
export { ForwardRef as ReactComponent };